module.exports = __webpack_public_path__ + "images/icons_v2/volume-high-filled-ffcd9e94.svg";